
window.___gcfg = {
    lang: "en-GB",
    parsetags: "onload"
};

new WOW({ offset: 70 }).init();

$(document).ready(function () {

    function eventQuote() {

        var itemCount = $(".quote-button__indicator");

        var currentQuoteItems = getQuoteItems();
        itemCount.text(currentQuoteItems.length);
        populateQuoteForm(currentQuoteItems);


        function addToQuote(e) {

            e.preventDefault();
            var asset = {
                id: e.target.dataset.assetId,
                name: e.target.dataset.assetName
            }
            addToStore(asset);

            $("#addedToQuote .modal-body").html("<p> " + asset.name + " added to quote </p>");
            $("#addedToQuote").modal();

        }

        function addToStore(asset) {
            // add item to session storage
            sessionStorage.setItem("quote-item-" + asset.id, JSON.stringify(asset));
            // update counter & enquiry form
            var currentQuoteItems = getQuoteItems();
            itemCount.text(currentQuoteItems.length);
            populateQuoteForm(currentQuoteItems);
        }

        function removeFromStore(asset) {
            // remove item from session storage
            sessionStorage.removeItem("quote-item-" + asset.id);
            // update counter & enquiry form
            var currentQuoteItems = getQuoteItems();
            itemCount.text(currentQuoteItems.length);
            populateQuoteForm(currentQuoteItems);
        }


        function tableClicks(e) {

            var assetId = e.target.value;
            var label = $(e.target).next();
            var assetName = label.text();

            var asset = {
                id: assetId,
                name: assetName
            };


            if (e.target.checked === true) {
                addToStore(asset);
            }
            if (e.target.checked === false) {
                label.css("font-weight", "normal");
                removeFromStore(asset);
            }
        }

        function getQuoteItems() {
            var quoteItems = [];

            for (var i = 0; i < sessionStorage.length; i++) {
                var currentItem = sessionStorage.key(i);
                if (currentItem.indexOf("quote-item") > -1) {
                    quoteItems.push(JSON.parse(sessionStorage.getItem(currentItem)));
                }
            }

            return quoteItems;

        }

        function populateQuoteForm(quoteItems) {

            for (var i = 0; i < quoteItems.length; i++) {
                $("#quoteForm .MultipleCastlesTable input[value=" + quoteItems[i].id + "]").attr("checked", true).next().css("font-weight", "bold");
            }

        }




        function showQuoteForm(e) {
            e.preventDefault();

            var addedtoQuoteModal = $("#addedToQuote");
            // is add to quote modal still open ?

            if (addedtoQuoteModal.hasClass("in")) {
                addedtoQuoteModal.modal('toggle');

                setTimeout(function () {
                    $('#quoteForm').modal();
                }, 400);
            }
            else {
                $('#quoteForm').modal();
            }
        }


        $('.add-to-quote').on('click', addToQuote);

        $('.quote-button, .show-quote').on('click', showQuoteForm);

        $('#quoteForm .MultipleCastlesTable').on('click', tableClicks);


    };

    $("#quoteForm  .innerColumn .row:last-child").css("margin-bottom", "30px").insertBefore($("#quoteForm .form-horizontal .form-group:last-child"));
    eventQuote();


    $("img.has-tooltip").tooltip({
        title: function () {
            return $(this).attr("alt");
        },
        placement: "auto"
    });

    $("a.has-tooltip").tooltip({
        placement: "auto"
    });


    $('.featured-categories__title').each(function (index, el) {
        $(el).addClass("wow fadeInUp2").attr("data-wow-delay", (index % 4) * 0.1 + "s");

    });






    $(window).on("resize", function () {
        setTimeout(function () {
            $('.testimonials__link').sameHeight();
        }, 300);
    }).resize();



    $('.banner #BannerImages').slick({
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<a href='#' class='banner__button banner__button--prev' aria-label='Previous' type='button'><img src='/theme/left-arrow.png' /></a>",
        nextArrow: "<a href='#' class='banner__button banner__button--next' aria-label='Previous' type='button'><img src='/theme/right-arrow.png' /></a>",
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

		
    });



    $('.clients__logo-panel').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 6,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [

            {
                breakpoint: 941,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },

            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1247,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 4
                }
            }


        ]
    });


    $('.testimonials__panel').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000

    });

    $(window).on("resize", function () {
        setTimeout(function () {



            $(".clients__carousel .carousel-inner").css("height", "auto");
            $(".clients__carousel .carousel-inner").sameHeight();
            $(".featured-categories__title").sameHeight();


        }, 300);
    }).resize();

    $('.clients__carousel').on('slide.bs.carousel', function (ev) {
        var dir = ev.direction == 'right' ? 'prev' : 'next';
        $('.clients__carousel').not('.sliding').addClass('sliding').carousel(dir);
    });
    $('.clients__carousel').on('slid.bs.carousel', function (ev) {
        $('.clients__carousel').removeClass('sliding');
    });

    var movementStrength = 15;
    var height = movementStrength / $(window).height();
    var width = movementStrength / $(window).width();
    $(".top-wrapper").mousemove(function (e) {
        var pageX = e.pageX - ($(window).width() / 3);
        var pageY = e.pageY - ($(window).height() / 3);
        var newvalueX = (width * pageX * -1 - 10) + ($(".top-wrapper").width() / 3) - 620;
        var newvalueY = (height * pageY * -1 - 10) + 0;
        $(".top-wrapper-back").css("background-position", newvalueX + "px     " + newvalueY + "px");
    });



});
